(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired6e5"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired6e5"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("dvYFb", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $9d6d3a12581f8329$export$5f0017c582d45a2d; });
function $9d6d3a12581f8329$export$5f0017c582d45a2d(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}

});

/** Focus Trap - Import */ /*!
* focus-trap 7.5.4
* @license MIT, https://github.com/focus-trap/focus-trap/blob/master/LICENSE
*/ 
var $dvYFb = parcelRequire("dvYFb");
/*!
* tabbable 6.2.0
* @license MIT, https://github.com/focus-trap/tabbable/blob/master/LICENSE
*/ // NOTE: separate `:not()` selectors has broader browser support than the newer
//  `:not([inert], [inert] *)` (Feb 2023)
// CAREFUL: JSDom does not support `:not([inert] *)` as a selector; using it causes
//  the entire query to fail, resulting in no nodes found, which will break a lot
//  of things... so we have to rely on JS to identify nodes inside an inert container
var $1a0c6bd09b300b0d$var$candidateSelectors = [
    "input:not([inert])",
    "select:not([inert])",
    "textarea:not([inert])",
    "a[href]:not([inert])",
    "button:not([inert])",
    "[tabindex]:not(slot):not([inert])",
    "audio[controls]:not([inert])",
    "video[controls]:not([inert])",
    '[contenteditable]:not([contenteditable="false"]):not([inert])',
    "details>summary:first-of-type:not([inert])",
    "details:not([inert])"
];
var $1a0c6bd09b300b0d$var$candidateSelector = /* #__PURE__ */ $1a0c6bd09b300b0d$var$candidateSelectors.join(",");
var $1a0c6bd09b300b0d$var$NoElement = typeof Element === "undefined";
var $1a0c6bd09b300b0d$var$matches = $1a0c6bd09b300b0d$var$NoElement ? function matches() {} : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
var $1a0c6bd09b300b0d$var$getRootNode = !$1a0c6bd09b300b0d$var$NoElement && Element.prototype.getRootNode ? function getRootNode(element) {
    var _element$getRootNode;
    return element === null || element === void 0 ? void 0 : (_element$getRootNode = element.getRootNode) === null || _element$getRootNode === void 0 ? void 0 : _element$getRootNode.call(element);
} : function(element) {
    return element === null || element === void 0 ? void 0 : element.ownerDocument;
};
/**
 * Determines if a node is inert or in an inert ancestor.
 * @param {Element} [node]
 * @param {boolean} [lookUp] If true and `node` is not inert, looks up at ancestors to
 *  see if any of them are inert. If false, only `node` itself is considered.
 * @returns {boolean} True if inert itself or by way of being in an inert ancestor.
 *  False if `node` is falsy.
 */ var $1a0c6bd09b300b0d$var$isInert = function isInert(node, lookUp) {
    var _node$getAttribute;
    if (lookUp === void 0) lookUp = true;
    // CAREFUL: JSDom does not support inert at all, so we can't use the `HTMLElement.inert`
    //  JS API property; we have to check the attribute, which can either be empty or 'true';
    //  if it's `null` (not specified) or 'false', it's an active element
    var inertAtt = node === null || node === void 0 ? void 0 : (_node$getAttribute = node.getAttribute) === null || _node$getAttribute === void 0 ? void 0 : _node$getAttribute.call(node, "inert");
    var inert = inertAtt === "" || inertAtt === "true";
    // NOTE: this could also be handled with `node.matches('[inert], :is([inert] *)')`
    //  if it weren't for `matches()` not being a function on shadow roots; the following
    //  code works for any kind of node
    // CAREFUL: JSDom does not appear to support certain selectors like `:not([inert] *)`
    //  so it likely would not support `:is([inert] *)` either...
    var result = inert || lookUp && node && isInert(node.parentNode); // recursive
    return result;
};
/**
 * Determines if a node's content is editable.
 * @param {Element} [node]
 * @returns True if it's content-editable; false if it's not or `node` is falsy.
 */ var $1a0c6bd09b300b0d$var$isContentEditable = function isContentEditable(node) {
    var _node$getAttribute2;
    // CAREFUL: JSDom does not support the `HTMLElement.isContentEditable` API so we have
    //  to use the attribute directly to check for this, which can either be empty or 'true';
    //  if it's `null` (not specified) or 'false', it's a non-editable element
    var attValue = node === null || node === void 0 ? void 0 : (_node$getAttribute2 = node.getAttribute) === null || _node$getAttribute2 === void 0 ? void 0 : _node$getAttribute2.call(node, "contenteditable");
    return attValue === "" || attValue === "true";
};
/**
 * @param {Element} el container to check in
 * @param {boolean} includeContainer add container to check
 * @param {(node: Element) => boolean} filter filter candidates
 * @returns {Element[]}
 */ var $1a0c6bd09b300b0d$var$getCandidates = function getCandidates(el, includeContainer, filter) {
    // even if `includeContainer=false`, we still have to check it for inertness because
    //  if it's inert, all its children are inert
    if ($1a0c6bd09b300b0d$var$isInert(el)) return [];
    var candidates = Array.prototype.slice.apply(el.querySelectorAll($1a0c6bd09b300b0d$var$candidateSelector));
    if (includeContainer && $1a0c6bd09b300b0d$var$matches.call(el, $1a0c6bd09b300b0d$var$candidateSelector)) candidates.unshift(el);
    candidates = candidates.filter(filter);
    return candidates;
};
/**
 * @callback GetShadowRoot
 * @param {Element} element to check for shadow root
 * @returns {ShadowRoot|boolean} ShadowRoot if available or boolean indicating if a shadowRoot is attached but not available.
 */ /**
 * @callback ShadowRootFilter
 * @param {Element} shadowHostNode the element which contains shadow content
 * @returns {boolean} true if a shadow root could potentially contain valid candidates.
 */ /**
 * @typedef {Object} CandidateScope
 * @property {Element} scopeParent contains inner candidates
 * @property {Element[]} candidates list of candidates found in the scope parent
 */ /**
 * @typedef {Object} IterativeOptions
 * @property {GetShadowRoot|boolean} getShadowRoot true if shadow support is enabled; falsy if not;
 *  if a function, implies shadow support is enabled and either returns the shadow root of an element
 *  or a boolean stating if it has an undisclosed shadow root
 * @property {(node: Element) => boolean} filter filter candidates
 * @property {boolean} flatten if true then result will flatten any CandidateScope into the returned list
 * @property {ShadowRootFilter} shadowRootFilter filter shadow roots;
 */ /**
 * @param {Element[]} elements list of element containers to match candidates from
 * @param {boolean} includeContainer add container list to check
 * @param {IterativeOptions} options
 * @returns {Array.<Element|CandidateScope>}
 */ var $1a0c6bd09b300b0d$var$getCandidatesIteratively = function getCandidatesIteratively(elements, includeContainer, options) {
    var candidates = [];
    var elementsToCheck = Array.from(elements);
    while(elementsToCheck.length){
        var element = elementsToCheck.shift();
        if ($1a0c6bd09b300b0d$var$isInert(element, false)) continue;
        if (element.tagName === "SLOT") {
            // add shadow dom slot scope (slot itself cannot be focusable)
            var assigned = element.assignedElements();
            var content = assigned.length ? assigned : element.children;
            var nestedCandidates = getCandidatesIteratively(content, true, options);
            if (options.flatten) candidates.push.apply(candidates, nestedCandidates);
            else candidates.push({
                scopeParent: element,
                candidates: nestedCandidates
            });
        } else {
            // check candidate element
            var validCandidate = $1a0c6bd09b300b0d$var$matches.call(element, $1a0c6bd09b300b0d$var$candidateSelector);
            if (validCandidate && options.filter(element) && (includeContainer || !elements.includes(element))) candidates.push(element);
            // iterate over shadow content if possible
            var shadowRoot = element.shadowRoot || // check for an undisclosed shadow
            typeof options.getShadowRoot === "function" && options.getShadowRoot(element);
            // no inert look up because we're already drilling down and checking for inertness
            //  on the way down, so all containers to this root node should have already been
            //  vetted as non-inert
            var validShadowRoot = !$1a0c6bd09b300b0d$var$isInert(shadowRoot, false) && (!options.shadowRootFilter || options.shadowRootFilter(element));
            if (shadowRoot && validShadowRoot) {
                // add shadow dom scope IIF a shadow root node was given; otherwise, an undisclosed
                //  shadow exists, so look at light dom children as fallback BUT create a scope for any
                //  child candidates found because they're likely slotted elements (elements that are
                //  children of the web component element (which has the shadow), in the light dom, but
                //  slotted somewhere _inside_ the undisclosed shadow) -- the scope is created below,
                //  _after_ we return from this recursive call
                var _nestedCandidates = getCandidatesIteratively(shadowRoot === true ? element.children : shadowRoot.children, true, options);
                if (options.flatten) candidates.push.apply(candidates, _nestedCandidates);
                else candidates.push({
                    scopeParent: element,
                    candidates: _nestedCandidates
                });
            } else // there's not shadow so just dig into the element's (light dom) children
            //  __without__ giving the element special scope treatment
            elementsToCheck.unshift.apply(elementsToCheck, element.children);
        }
    }
    return candidates;
};
/**
 * @private
 * Determines if the node has an explicitly specified `tabindex` attribute.
 * @param {HTMLElement} node
 * @returns {boolean} True if so; false if not.
 */ var $1a0c6bd09b300b0d$var$hasTabIndex = function hasTabIndex(node) {
    return !isNaN(parseInt(node.getAttribute("tabindex"), 10));
};
/**
 * Determine the tab index of a given node.
 * @param {HTMLElement} node
 * @returns {number} Tab order (negative, 0, or positive number).
 * @throws {Error} If `node` is falsy.
 */ var $1a0c6bd09b300b0d$export$a4672efddb4181b8 = function getTabIndex(node) {
    if (!node) throw new Error("No node provided");
    if (node.tabIndex < 0) {
        // in Chrome, <details/>, <audio controls/> and <video controls/> elements get a default
        // `tabIndex` of -1 when the 'tabindex' attribute isn't specified in the DOM,
        // yet they are still part of the regular tab order; in FF, they get a default
        // `tabIndex` of 0; since Chrome still puts those elements in the regular tab
        // order, consider their tab index to be 0.
        // Also browsers do not return `tabIndex` correctly for contentEditable nodes;
        // so if they don't have a tabindex attribute specifically set, assume it's 0.
        if ((/^(AUDIO|VIDEO|DETAILS)$/.test(node.tagName) || $1a0c6bd09b300b0d$var$isContentEditable(node)) && !$1a0c6bd09b300b0d$var$hasTabIndex(node)) return 0;
    }
    return node.tabIndex;
};
/**
 * Determine the tab index of a given node __for sort order purposes__.
 * @param {HTMLElement} node
 * @param {boolean} [isScope] True for a custom element with shadow root or slot that, by default,
 *  has tabIndex -1, but needs to be sorted by document order in order for its content to be
 *  inserted into the correct sort position.
 * @returns {number} Tab order (negative, 0, or positive number).
 */ var $1a0c6bd09b300b0d$var$getSortOrderTabIndex = function getSortOrderTabIndex(node, isScope) {
    var tabIndex = $1a0c6bd09b300b0d$export$a4672efddb4181b8(node);
    if (tabIndex < 0 && isScope && !$1a0c6bd09b300b0d$var$hasTabIndex(node)) return 0;
    return tabIndex;
};
var $1a0c6bd09b300b0d$var$sortOrderedTabbables = function sortOrderedTabbables(a, b) {
    return a.tabIndex === b.tabIndex ? a.documentOrder - b.documentOrder : a.tabIndex - b.tabIndex;
};
var $1a0c6bd09b300b0d$var$isInput = function isInput(node) {
    return node.tagName === "INPUT";
};
var $1a0c6bd09b300b0d$var$isHiddenInput = function isHiddenInput(node) {
    return $1a0c6bd09b300b0d$var$isInput(node) && node.type === "hidden";
};
var $1a0c6bd09b300b0d$var$isDetailsWithSummary = function isDetailsWithSummary(node) {
    var r = node.tagName === "DETAILS" && Array.prototype.slice.apply(node.children).some(function(child) {
        return child.tagName === "SUMMARY";
    });
    return r;
};
var $1a0c6bd09b300b0d$var$getCheckedRadio = function getCheckedRadio(nodes, form) {
    for(var i = 0; i < nodes.length; i++){
        if (nodes[i].checked && nodes[i].form === form) return nodes[i];
    }
};
var $1a0c6bd09b300b0d$var$isTabbableRadio = function isTabbableRadio(node) {
    if (!node.name) return true;
    var radioScope = node.form || $1a0c6bd09b300b0d$var$getRootNode(node);
    var queryRadios = function queryRadios(name) {
        return radioScope.querySelectorAll('input[type="radio"][name="' + name + '"]');
    };
    var radioSet;
    if (typeof window !== "undefined" && typeof window.CSS !== "undefined" && typeof window.CSS.escape === "function") radioSet = queryRadios(window.CSS.escape(node.name));
    else try {
        radioSet = queryRadios(node.name);
    } catch (err) {
        // eslint-disable-next-line no-console
        console.error("Looks like you have a radio button with a name attribute containing invalid CSS selector characters and need the CSS.escape polyfill: %s", err.message);
        return false;
    }
    var checked = $1a0c6bd09b300b0d$var$getCheckedRadio(radioSet, node.form);
    return !checked || checked === node;
};
var $1a0c6bd09b300b0d$var$isRadio = function isRadio(node) {
    return $1a0c6bd09b300b0d$var$isInput(node) && node.type === "radio";
};
var $1a0c6bd09b300b0d$var$isNonTabbableRadio = function isNonTabbableRadio(node) {
    return $1a0c6bd09b300b0d$var$isRadio(node) && !$1a0c6bd09b300b0d$var$isTabbableRadio(node);
};
// determines if a node is ultimately attached to the window's document
var $1a0c6bd09b300b0d$var$isNodeAttached = function isNodeAttached(node) {
    var _nodeRoot;
    // The root node is the shadow root if the node is in a shadow DOM; some document otherwise
    //  (but NOT _the_ document; see second 'If' comment below for more).
    // If rootNode is shadow root, it'll have a host, which is the element to which the shadow
    //  is attached, and the one we need to check if it's in the document or not (because the
    //  shadow, and all nodes it contains, is never considered in the document since shadows
    //  behave like self-contained DOMs; but if the shadow's HOST, which is part of the document,
    //  is hidden, or is not in the document itself but is detached, it will affect the shadow's
    //  visibility, including all the nodes it contains). The host could be any normal node,
    //  or a custom element (i.e. web component). Either way, that's the one that is considered
    //  part of the document, not the shadow root, nor any of its children (i.e. the node being
    //  tested).
    // To further complicate things, we have to look all the way up until we find a shadow HOST
    //  that is attached (or find none) because the node might be in nested shadows...
    // If rootNode is not a shadow root, it won't have a host, and so rootNode should be the
    //  document (per the docs) and while it's a Document-type object, that document does not
    //  appear to be the same as the node's `ownerDocument` for some reason, so it's safer
    //  to ignore the rootNode at this point, and use `node.ownerDocument`. Otherwise,
    //  using `rootNode.contains(node)` will _always_ be true we'll get false-positives when
    //  node is actually detached.
    // NOTE: If `nodeRootHost` or `node` happens to be the `document` itself (which is possible
    //  if a tabbable/focusable node was quickly added to the DOM, focused, and then removed
    //  from the DOM as in https://github.com/focus-trap/focus-trap-react/issues/905), then
    //  `ownerDocument` will be `null`, hence the optional chaining on it.
    var nodeRoot = node && $1a0c6bd09b300b0d$var$getRootNode(node);
    var nodeRootHost = (_nodeRoot = nodeRoot) === null || _nodeRoot === void 0 ? void 0 : _nodeRoot.host;
    // in some cases, a detached node will return itself as the root instead of a document or
    //  shadow root object, in which case, we shouldn't try to look further up the host chain
    var attached = false;
    if (nodeRoot && nodeRoot !== node) {
        var _nodeRootHost, _nodeRootHost$ownerDo, _node$ownerDocument;
        attached = !!((_nodeRootHost = nodeRootHost) !== null && _nodeRootHost !== void 0 && (_nodeRootHost$ownerDo = _nodeRootHost.ownerDocument) !== null && _nodeRootHost$ownerDo !== void 0 && _nodeRootHost$ownerDo.contains(nodeRootHost) || node !== null && node !== void 0 && (_node$ownerDocument = node.ownerDocument) !== null && _node$ownerDocument !== void 0 && _node$ownerDocument.contains(node));
        while(!attached && nodeRootHost){
            var _nodeRoot2, _nodeRootHost2, _nodeRootHost2$ownerD;
            // since it's not attached and we have a root host, the node MUST be in a nested shadow DOM,
            //  which means we need to get the host's host and check if that parent host is contained
            //  in (i.e. attached to) the document
            nodeRoot = $1a0c6bd09b300b0d$var$getRootNode(nodeRootHost);
            nodeRootHost = (_nodeRoot2 = nodeRoot) === null || _nodeRoot2 === void 0 ? void 0 : _nodeRoot2.host;
            attached = !!((_nodeRootHost2 = nodeRootHost) !== null && _nodeRootHost2 !== void 0 && (_nodeRootHost2$ownerD = _nodeRootHost2.ownerDocument) !== null && _nodeRootHost2$ownerD !== void 0 && _nodeRootHost2$ownerD.contains(nodeRootHost));
        }
    }
    return attached;
};
var $1a0c6bd09b300b0d$var$isZeroArea = function isZeroArea(node) {
    var _node$getBoundingClie = node.getBoundingClientRect(), width = _node$getBoundingClie.width, height = _node$getBoundingClie.height;
    return width === 0 && height === 0;
};
var $1a0c6bd09b300b0d$var$isHidden = function isHidden(node, _ref) {
    var displayCheck = _ref.displayCheck, getShadowRoot = _ref.getShadowRoot;
    // NOTE: visibility will be `undefined` if node is detached from the document
    //  (see notes about this further down), which means we will consider it visible
    //  (this is legacy behavior from a very long way back)
    // NOTE: we check this regardless of `displayCheck="none"` because this is a
    //  _visibility_ check, not a _display_ check
    if (getComputedStyle(node).visibility === "hidden") return true;
    var isDirectSummary = $1a0c6bd09b300b0d$var$matches.call(node, "details>summary:first-of-type");
    var nodeUnderDetails = isDirectSummary ? node.parentElement : node;
    if ($1a0c6bd09b300b0d$var$matches.call(nodeUnderDetails, "details:not([open]) *")) return true;
    if (!displayCheck || displayCheck === "full" || displayCheck === "legacy-full") {
        if (typeof getShadowRoot === "function") {
            // figure out if we should consider the node to be in an undisclosed shadow and use the
            //  'non-zero-area' fallback
            var originalNode = node;
            while(node){
                var parentElement = node.parentElement;
                var rootNode = $1a0c6bd09b300b0d$var$getRootNode(node);
                if (parentElement && !parentElement.shadowRoot && getShadowRoot(parentElement) === true // check if there's an undisclosed shadow
                ) // node has an undisclosed shadow which means we can only treat it as a black box, so we
                //  fall back to a non-zero-area test
                return $1a0c6bd09b300b0d$var$isZeroArea(node);
                else if (node.assignedSlot) // iterate up slot
                node = node.assignedSlot;
                else if (!parentElement && rootNode !== node.ownerDocument) // cross shadow boundary
                node = rootNode.host;
                else // iterate up normal dom
                node = parentElement;
            }
            node = originalNode;
        }
        // else, `getShadowRoot` might be true, but all that does is enable shadow DOM support
        //  (i.e. it does not also presume that all nodes might have undisclosed shadows); or
        //  it might be a falsy value, which means shadow DOM support is disabled
        // Since we didn't find it sitting in an undisclosed shadow (or shadows are disabled)
        //  now we can just test to see if it would normally be visible or not, provided it's
        //  attached to the main document.
        // NOTE: We must consider case where node is inside a shadow DOM and given directly to
        //  `isTabbable()` or `isFocusable()` -- regardless of `getShadowRoot` option setting.
        if ($1a0c6bd09b300b0d$var$isNodeAttached(node)) // this works wherever the node is: if there's at least one client rect, it's
        //  somehow displayed; it also covers the CSS 'display: contents' case where the
        //  node itself is hidden in place of its contents; and there's no need to search
        //  up the hierarchy either
        return !node.getClientRects().length;
        // Else, the node isn't attached to the document, which means the `getClientRects()`
        //  API will __always__ return zero rects (this can happen, for example, if React
        //  is used to render nodes onto a detached tree, as confirmed in this thread:
        //  https://github.com/facebook/react/issues/9117#issuecomment-284228870)
        //
        // It also means that even window.getComputedStyle(node).display will return `undefined`
        //  because styles are only computed for nodes that are in the document.
        //
        // NOTE: THIS HAS BEEN THE CASE FOR YEARS. It is not new, nor is it caused by tabbable
        //  somehow. Though it was never stated officially, anyone who has ever used tabbable
        //  APIs on nodes in detached containers has actually implicitly used tabbable in what
        //  was later (as of v5.2.0 on Apr 9, 2021) called `displayCheck="none"` mode -- essentially
        //  considering __everything__ to be visible because of the innability to determine styles.
        //
        // v6.0.0: As of this major release, the default 'full' option __no longer treats detached
        //  nodes as visible with the 'none' fallback.__
        if (displayCheck !== "legacy-full") return true; // hidden
    // else, fallback to 'none' mode and consider the node visible
    } else if (displayCheck === "non-zero-area") // NOTE: Even though this tests that the node's client rect is non-zero to determine
    //  whether it's displayed, and that a detached node will __always__ have a zero-area
    //  client rect, we don't special-case for whether the node is attached or not. In
    //  this mode, we do want to consider nodes that have a zero area to be hidden at all
    //  times, and that includes attached or not.
    return $1a0c6bd09b300b0d$var$isZeroArea(node);
    // visible, as far as we can tell, or per current `displayCheck=none` mode, we assume
    //  it's visible
    return false;
};
// form fields (nested) inside a disabled fieldset are not focusable/tabbable
//  unless they are in the _first_ <legend> element of the top-most disabled
//  fieldset
var $1a0c6bd09b300b0d$var$isDisabledFromFieldset = function isDisabledFromFieldset(node) {
    if (/^(INPUT|BUTTON|SELECT|TEXTAREA)$/.test(node.tagName)) {
        var parentNode = node.parentElement;
        // check if `node` is contained in a disabled <fieldset>
        while(parentNode){
            if (parentNode.tagName === "FIELDSET" && parentNode.disabled) {
                // look for the first <legend> among the children of the disabled <fieldset>
                for(var i = 0; i < parentNode.children.length; i++){
                    var child = parentNode.children.item(i);
                    // when the first <legend> (in document order) is found
                    if (child.tagName === "LEGEND") // if its parent <fieldset> is not nested in another disabled <fieldset>,
                    // return whether `node` is a descendant of its first <legend>
                    return $1a0c6bd09b300b0d$var$matches.call(parentNode, "fieldset[disabled] *") ? true : !child.contains(node);
                }
                // the disabled <fieldset> containing `node` has no <legend>
                return true;
            }
            parentNode = parentNode.parentElement;
        }
    }
    // else, node's tabbable/focusable state should not be affected by a fieldset's
    //  enabled/disabled state
    return false;
};
var $1a0c6bd09b300b0d$var$isNodeMatchingSelectorFocusable = function isNodeMatchingSelectorFocusable(options, node) {
    if (node.disabled || // we must do an inert look up to filter out any elements inside an inert ancestor
    //  because we're limited in the type of selectors we can use in JSDom (see related
    //  note related to `candidateSelectors`)
    $1a0c6bd09b300b0d$var$isInert(node) || $1a0c6bd09b300b0d$var$isHiddenInput(node) || $1a0c6bd09b300b0d$var$isHidden(node, options) || // For a details element with a summary, the summary element gets the focus
    $1a0c6bd09b300b0d$var$isDetailsWithSummary(node) || $1a0c6bd09b300b0d$var$isDisabledFromFieldset(node)) return false;
    return true;
};
var $1a0c6bd09b300b0d$var$isNodeMatchingSelectorTabbable = function isNodeMatchingSelectorTabbable(options, node) {
    if ($1a0c6bd09b300b0d$var$isNonTabbableRadio(node) || $1a0c6bd09b300b0d$export$a4672efddb4181b8(node) < 0 || !$1a0c6bd09b300b0d$var$isNodeMatchingSelectorFocusable(options, node)) return false;
    return true;
};
var $1a0c6bd09b300b0d$var$isValidShadowRootTabbable = function isValidShadowRootTabbable(shadowHostNode) {
    var tabIndex = parseInt(shadowHostNode.getAttribute("tabindex"), 10);
    if (isNaN(tabIndex) || tabIndex >= 0) return true;
    // If a custom element has an explicit negative tabindex,
    // browsers will not allow tab targeting said element's children.
    return false;
};
/**
 * @param {Array.<Element|CandidateScope>} candidates
 * @returns Element[]
 */ var $1a0c6bd09b300b0d$var$sortByOrder = function sortByOrder(candidates) {
    var regularTabbables = [];
    var orderedTabbables = [];
    candidates.forEach(function(item, i) {
        var isScope = !!item.scopeParent;
        var element = isScope ? item.scopeParent : item;
        var candidateTabindex = $1a0c6bd09b300b0d$var$getSortOrderTabIndex(element, isScope);
        var elements = isScope ? sortByOrder(item.candidates) : element;
        if (candidateTabindex === 0) isScope ? regularTabbables.push.apply(regularTabbables, elements) : regularTabbables.push(element);
        else orderedTabbables.push({
            documentOrder: i,
            tabIndex: candidateTabindex,
            item: item,
            isScope: isScope,
            content: elements
        });
    });
    return orderedTabbables.sort($1a0c6bd09b300b0d$var$sortOrderedTabbables).reduce(function(acc, sortable) {
        sortable.isScope ? acc.push.apply(acc, sortable.content) : acc.push(sortable.content);
        return acc;
    }, []).concat(regularTabbables);
};
var $1a0c6bd09b300b0d$export$17100aea90429aa7 = function tabbable(container, options) {
    options = options || {};
    var candidates;
    if (options.getShadowRoot) candidates = $1a0c6bd09b300b0d$var$getCandidatesIteratively([
        container
    ], options.includeContainer, {
        filter: $1a0c6bd09b300b0d$var$isNodeMatchingSelectorTabbable.bind(null, options),
        flatten: false,
        getShadowRoot: options.getShadowRoot,
        shadowRootFilter: $1a0c6bd09b300b0d$var$isValidShadowRootTabbable
    });
    else candidates = $1a0c6bd09b300b0d$var$getCandidates(container, options.includeContainer, $1a0c6bd09b300b0d$var$isNodeMatchingSelectorTabbable.bind(null, options));
    return $1a0c6bd09b300b0d$var$sortByOrder(candidates);
};
var $1a0c6bd09b300b0d$export$ecc6d1fcdff4f700 = function focusable(container, options) {
    options = options || {};
    var candidates;
    if (options.getShadowRoot) candidates = $1a0c6bd09b300b0d$var$getCandidatesIteratively([
        container
    ], options.includeContainer, {
        filter: $1a0c6bd09b300b0d$var$isNodeMatchingSelectorFocusable.bind(null, options),
        flatten: true,
        getShadowRoot: options.getShadowRoot
    });
    else candidates = $1a0c6bd09b300b0d$var$getCandidates(container, options.includeContainer, $1a0c6bd09b300b0d$var$isNodeMatchingSelectorFocusable.bind(null, options));
    return candidates;
};
var $1a0c6bd09b300b0d$export$bebd5a1431fec25d = function isTabbable(node, options) {
    options = options || {};
    if (!node) throw new Error("No node provided");
    if ($1a0c6bd09b300b0d$var$matches.call(node, $1a0c6bd09b300b0d$var$candidateSelector) === false) return false;
    return $1a0c6bd09b300b0d$var$isNodeMatchingSelectorTabbable(options, node);
};
var $1a0c6bd09b300b0d$var$focusableCandidateSelector = /* #__PURE__ */ $1a0c6bd09b300b0d$var$candidateSelectors.concat("iframe").join(",");
var $1a0c6bd09b300b0d$export$4c063cf1350e6fed = function isFocusable(node, options) {
    options = options || {};
    if (!node) throw new Error("No node provided");
    if ($1a0c6bd09b300b0d$var$matches.call(node, $1a0c6bd09b300b0d$var$focusableCandidateSelector) === false) return false;
    return $1a0c6bd09b300b0d$var$isNodeMatchingSelectorFocusable(options, node);
};


function $d5bc75faf976d2ed$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $d5bc75faf976d2ed$var$_objectSpread2(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $d5bc75faf976d2ed$var$ownKeys(Object(t), !0).forEach(function(r) {
            $d5bc75faf976d2ed$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $d5bc75faf976d2ed$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $d5bc75faf976d2ed$var$_defineProperty(obj, key, value) {
    key = $d5bc75faf976d2ed$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $d5bc75faf976d2ed$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $d5bc75faf976d2ed$var$_toPropertyKey(arg) {
    var key = $d5bc75faf976d2ed$var$_toPrimitive(arg, "string");
    return (typeof key === "undefined" ? "undefined" : (0, $dvYFb._)(key)) === "symbol" ? key : String(key);
}
var $d5bc75faf976d2ed$var$activeFocusTraps = {
    activateTrap: function activateTrap(trapStack, trap) {
        if (trapStack.length > 0) {
            var activeTrap = trapStack[trapStack.length - 1];
            if (activeTrap !== trap) activeTrap.pause();
        }
        var trapIndex = trapStack.indexOf(trap);
        if (trapIndex === -1) trapStack.push(trap);
        else {
            // move this existing trap to the front of the queue
            trapStack.splice(trapIndex, 1);
            trapStack.push(trap);
        }
    },
    deactivateTrap: function deactivateTrap(trapStack, trap) {
        var trapIndex = trapStack.indexOf(trap);
        if (trapIndex !== -1) trapStack.splice(trapIndex, 1);
        if (trapStack.length > 0) trapStack[trapStack.length - 1].unpause();
    }
};
var $d5bc75faf976d2ed$var$isSelectableInput = function isSelectableInput(node) {
    return node.tagName && node.tagName.toLowerCase() === "input" && typeof node.select === "function";
};
var $d5bc75faf976d2ed$var$isEscapeEvent = function isEscapeEvent(e) {
    return (e === null || e === void 0 ? void 0 : e.key) === "Escape" || (e === null || e === void 0 ? void 0 : e.key) === "Esc" || (e === null || e === void 0 ? void 0 : e.keyCode) === 27;
};
var $d5bc75faf976d2ed$var$isTabEvent = function isTabEvent(e) {
    return (e === null || e === void 0 ? void 0 : e.key) === "Tab" || (e === null || e === void 0 ? void 0 : e.keyCode) === 9;
};
// checks for TAB by default
var $d5bc75faf976d2ed$var$isKeyForward = function isKeyForward(e) {
    return $d5bc75faf976d2ed$var$isTabEvent(e) && !e.shiftKey;
};
// checks for SHIFT+TAB by default
var $d5bc75faf976d2ed$var$isKeyBackward = function isKeyBackward(e) {
    return $d5bc75faf976d2ed$var$isTabEvent(e) && e.shiftKey;
};
var $d5bc75faf976d2ed$var$delay = function delay(fn) {
    return setTimeout(fn, 0);
};
// Array.find/findIndex() are not supported on IE; this replicates enough
//  of Array.findIndex() for our needs
var $d5bc75faf976d2ed$var$findIndex = function findIndex(arr, fn) {
    var idx = -1;
    arr.every(function(value, i) {
        if (fn(value)) {
            idx = i;
            return false; // break
        }
        return true; // next
    });
    return idx;
};
/**
 * Get an option's value when it could be a plain value, or a handler that provides
 *  the value.
 * @param {*} value Option's value to check.
 * @param {...*} [params] Any parameters to pass to the handler, if `value` is a function.
 * @returns {*} The `value`, or the handler's returned value.
 */ var $d5bc75faf976d2ed$var$valueOrHandler = function valueOrHandler(value) {
    for(var _len = arguments.length, params = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)params[_key - 1] = arguments[_key];
    return typeof value === "function" ? value.apply(void 0, params) : value;
};
var $d5bc75faf976d2ed$var$getActualTarget = function getActualTarget(event) {
    // NOTE: If the trap is _inside_ a shadow DOM, event.target will always be the
    //  shadow host. However, event.target.composedPath() will be an array of
    //  nodes "clicked" from inner-most (the actual element inside the shadow) to
    //  outer-most (the host HTML document). If we have access to composedPath(),
    //  then use its first element; otherwise, fall back to event.target (and
    //  this only works for an _open_ shadow DOM; otherwise,
    //  composedPath()[0] === event.target always).
    return event.target.shadowRoot && typeof event.composedPath === "function" ? event.composedPath()[0] : event.target;
};
// NOTE: this must be _outside_ `createFocusTrap()` to make sure all traps in this
//  current instance use the same stack if `userOptions.trapStack` isn't specified
var $d5bc75faf976d2ed$var$internalTrapStack = [];
var $d5bc75faf976d2ed$export$360440dfcba94c00 = function createFocusTrap(elements, userOptions) {
    // SSR: a live trap shouldn't be created in this type of environment so this
    //  should be safe code to execute if the `document` option isn't specified
    var doc = (userOptions === null || userOptions === void 0 ? void 0 : userOptions.document) || document;
    var trapStack = (userOptions === null || userOptions === void 0 ? void 0 : userOptions.trapStack) || $d5bc75faf976d2ed$var$internalTrapStack;
    var config = $d5bc75faf976d2ed$var$_objectSpread2({
        returnFocusOnDeactivate: true,
        escapeDeactivates: true,
        delayInitialFocus: true,
        isKeyForward: $d5bc75faf976d2ed$var$isKeyForward,
        isKeyBackward: $d5bc75faf976d2ed$var$isKeyBackward
    }, userOptions);
    var state = {
        // containers given to createFocusTrap()
        // @type {Array<HTMLElement>}
        containers: [],
        // list of objects identifying tabbable nodes in `containers` in the trap
        // NOTE: it's possible that a group has no tabbable nodes if nodes get removed while the trap
        //  is active, but the trap should never get to a state where there isn't at least one group
        //  with at least one tabbable node in it (that would lead to an error condition that would
        //  result in an error being thrown)
        // @type {Array<{
        //   container: HTMLElement,
        //   tabbableNodes: Array<HTMLElement>, // empty if none
        //   focusableNodes: Array<HTMLElement>, // empty if none
        //   posTabIndexesFound: boolean,
        //   firstTabbableNode: HTMLElement|undefined,
        //   lastTabbableNode: HTMLElement|undefined,
        //   firstDomTabbableNode: HTMLElement|undefined,
        //   lastDomTabbableNode: HTMLElement|undefined,
        //   nextTabbableNode: (node: HTMLElement, forward: boolean) => HTMLElement|undefined
        // }>}
        containerGroups: [],
        // same order/length as `containers` list
        // references to objects in `containerGroups`, but only those that actually have
        //  tabbable nodes in them
        // NOTE: same order as `containers` and `containerGroups`, but __not necessarily__
        //  the same length
        tabbableGroups: [],
        nodeFocusedBeforeActivation: null,
        mostRecentlyFocusedNode: null,
        active: false,
        paused: false,
        // timer ID for when delayInitialFocus is true and initial focus in this trap
        //  has been delayed during activation
        delayInitialFocusTimer: undefined,
        // the most recent KeyboardEvent for the configured nav key (typically [SHIFT+]TAB), if any
        recentNavEvent: undefined
    };
    var trap; // eslint-disable-line prefer-const -- some private functions reference it, and its methods reference private functions, so we must declare here and define later
    /**
   * Gets a configuration option value.
   * @param {Object|undefined} configOverrideOptions If true, and option is defined in this set,
   *  value will be taken from this object. Otherwise, value will be taken from base configuration.
   * @param {string} optionName Name of the option whose value is sought.
   * @param {string|undefined} [configOptionName] Name of option to use __instead of__ `optionName`
   *  IIF `configOverrideOptions` is not defined. Otherwise, `optionName` is used.
   */ var getOption = function getOption(configOverrideOptions, optionName, configOptionName) {
        return configOverrideOptions && configOverrideOptions[optionName] !== undefined ? configOverrideOptions[optionName] : config[configOptionName || optionName];
    };
    /**
   * Finds the index of the container that contains the element.
   * @param {HTMLElement} element
   * @param {Event} [event] If available, and `element` isn't directly found in any container,
   *  the event's composed path is used to see if includes any known trap containers in the
   *  case where the element is inside a Shadow DOM.
   * @returns {number} Index of the container in either `state.containers` or
   *  `state.containerGroups` (the order/length of these lists are the same); -1
   *  if the element isn't found.
   */ var findContainerIndex = function findContainerIndex(element, event) {
        var composedPath = typeof (event === null || event === void 0 ? void 0 : event.composedPath) === "function" ? event.composedPath() : undefined;
        // NOTE: search `containerGroups` because it's possible a group contains no tabbable
        //  nodes, but still contains focusable nodes (e.g. if they all have `tabindex=-1`)
        //  and we still need to find the element in there
        return state.containerGroups.findIndex(function(_ref) {
            var container = _ref.container, tabbableNodes = _ref.tabbableNodes;
            return container.contains(element) || //  web components if the `tabbableOptions.getShadowRoot` option was used for
            //  the trap, enabling shadow DOM support in tabbable (`Node.contains()` doesn't
            //  look inside web components even if open)
            (composedPath === null || composedPath === void 0 ? void 0 : composedPath.includes(container)) || tabbableNodes.find(function(node) {
                return node === element;
            });
        });
    };
    /**
   * Gets the node for the given option, which is expected to be an option that
   *  can be either a DOM node, a string that is a selector to get a node, `false`
   *  (if a node is explicitly NOT given), or a function that returns any of these
   *  values.
   * @param {string} optionName
   * @returns {undefined | false | HTMLElement | SVGElement} Returns
   *  `undefined` if the option is not specified; `false` if the option
   *  resolved to `false` (node explicitly not given); otherwise, the resolved
   *  DOM node.
   * @throws {Error} If the option is set, not `false`, and is not, or does not
   *  resolve to a node.
   */ var getNodeForOption = function getNodeForOption(optionName) {
        var optionValue = config[optionName];
        if (typeof optionValue === "function") {
            for(var _len2 = arguments.length, params = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)params[_key2 - 1] = arguments[_key2];
            optionValue = optionValue.apply(void 0, params);
        }
        if (optionValue === true) optionValue = undefined; // use default value
        if (!optionValue) {
            if (optionValue === undefined || optionValue === false) return optionValue;
            // else, empty string (invalid), null (invalid), 0 (invalid)
            throw new Error("`".concat(optionName, "` was specified but was not a node, or did not return a node"));
        }
        var node = optionValue; // could be HTMLElement, SVGElement, or non-empty string at this point
        if (typeof optionValue === "string") {
            node = doc.querySelector(optionValue); // resolve to node, or null if fails
            if (!node) throw new Error("`".concat(optionName, "` as selector refers to no known node"));
        }
        return node;
    };
    var getInitialFocusNode = function getInitialFocusNode() {
        var node = getNodeForOption("initialFocus");
        // false explicitly indicates we want no initialFocus at all
        if (node === false) return false;
        if (node === undefined || !(0, $1a0c6bd09b300b0d$export$4c063cf1350e6fed)(node, config.tabbableOptions)) {
            // option not specified nor focusable: use fallback options
            if (findContainerIndex(doc.activeElement) >= 0) node = doc.activeElement;
            else {
                var firstTabbableGroup = state.tabbableGroups[0];
                var firstTabbableNode = firstTabbableGroup && firstTabbableGroup.firstTabbableNode;
                // NOTE: `fallbackFocus` option function cannot return `false` (not supported)
                node = firstTabbableNode || getNodeForOption("fallbackFocus");
            }
        }
        if (!node) throw new Error("Your focus-trap needs to have at least one focusable element");
        return node;
    };
    var updateTabbableNodes = function updateTabbableNodes() {
        state.containerGroups = state.containers.map(function(container) {
            var tabbableNodes = (0, $1a0c6bd09b300b0d$export$17100aea90429aa7)(container, config.tabbableOptions);
            // NOTE: if we have tabbable nodes, we must have focusable nodes; focusable nodes
            //  are a superset of tabbable nodes since nodes with negative `tabindex` attributes
            //  are focusable but not tabbable
            var focusableNodes = (0, $1a0c6bd09b300b0d$export$ecc6d1fcdff4f700)(container, config.tabbableOptions);
            var firstTabbableNode = tabbableNodes.length > 0 ? tabbableNodes[0] : undefined;
            var lastTabbableNode = tabbableNodes.length > 0 ? tabbableNodes[tabbableNodes.length - 1] : undefined;
            var firstDomTabbableNode = focusableNodes.find(function(node) {
                return (0, $1a0c6bd09b300b0d$export$bebd5a1431fec25d)(node);
            });
            var lastDomTabbableNode = focusableNodes.slice().reverse().find(function(node) {
                return (0, $1a0c6bd09b300b0d$export$bebd5a1431fec25d)(node);
            });
            var posTabIndexesFound = !!tabbableNodes.find(function(node) {
                return (0, $1a0c6bd09b300b0d$export$a4672efddb4181b8)(node) > 0;
            });
            return {
                container: container,
                tabbableNodes: tabbableNodes,
                focusableNodes: focusableNodes,
                /** True if at least one node with positive `tabindex` was found in this container. */ posTabIndexesFound: posTabIndexesFound,
                /** First tabbable node in container, __tabindex__ order; `undefined` if none. */ firstTabbableNode: firstTabbableNode,
                /** Last tabbable node in container, __tabindex__ order; `undefined` if none. */ lastTabbableNode: lastTabbableNode,
                // NOTE: DOM order is NOT NECESSARILY "document position" order, but figuring that out
                //  would require more than just https://developer.mozilla.org/en-US/docs/Web/API/Node/compareDocumentPosition
                //  because that API doesn't work with Shadow DOM as well as it should (@see
                //  https://github.com/whatwg/dom/issues/320) and since this first/last is only needed, so far,
                //  to address an edge case related to positive tabindex support, this seems like a much easier,
                //  "close enough most of the time" alternative for positive tabindexes which should generally
                //  be avoided anyway...
                /** First tabbable node in container, __DOM__ order; `undefined` if none. */ firstDomTabbableNode: firstDomTabbableNode,
                /** Last tabbable node in container, __DOM__ order; `undefined` if none. */ lastDomTabbableNode: lastDomTabbableNode,
                /**
         * Finds the __tabbable__ node that follows the given node in the specified direction,
         *  in this container, if any.
         * @param {HTMLElement} node
         * @param {boolean} [forward] True if going in forward tab order; false if going
         *  in reverse.
         * @returns {HTMLElement|undefined} The next tabbable node, if any.
         */ nextTabbableNode: function nextTabbableNode(node) {
                    var forward = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
                    var nodeIdx = tabbableNodes.indexOf(node);
                    if (nodeIdx < 0) {
                        // either not tabbable nor focusable, or was focused but not tabbable (negative tabindex):
                        //  since `node` should at least have been focusable, we assume that's the case and mimic
                        //  what browsers do, which is set focus to the next node in __document position order__,
                        //  regardless of positive tabindexes, if any -- and for reasons explained in the NOTE
                        //  above related to `firstDomTabbable` and `lastDomTabbable` properties, we fall back to
                        //  basic DOM order
                        if (forward) return focusableNodes.slice(focusableNodes.indexOf(node) + 1).find(function(el) {
                            return (0, $1a0c6bd09b300b0d$export$bebd5a1431fec25d)(el);
                        });
                        return focusableNodes.slice(0, focusableNodes.indexOf(node)).reverse().find(function(el) {
                            return (0, $1a0c6bd09b300b0d$export$bebd5a1431fec25d)(el);
                        });
                    }
                    return tabbableNodes[nodeIdx + (forward ? 1 : -1)];
                }
            };
        });
        state.tabbableGroups = state.containerGroups.filter(function(group) {
            return group.tabbableNodes.length > 0;
        });
        // throw if no groups have tabbable nodes and we don't have a fallback focus node either
        if (state.tabbableGroups.length <= 0 && !getNodeForOption("fallbackFocus") // returning false not supported for this option
        ) throw new Error("Your focus-trap must have at least one container with at least one tabbable node in it at all times");
        // NOTE: Positive tabindexes are only properly supported in single-container traps because
        //  doing it across multiple containers where tabindexes could be all over the place
        //  would require Tabbable to support multiple containers, would require additional
        //  specialized Shadow DOM support, and would require Tabbable's multi-container support
        //  to look at those containers in document position order rather than user-provided
        //  order (as they are treated in Focus-trap, for legacy reasons). See discussion on
        //  https://github.com/focus-trap/focus-trap/issues/375 for more details.
        if (state.containerGroups.find(function(g) {
            return g.posTabIndexesFound;
        }) && state.containerGroups.length > 1) throw new Error("At least one node with a positive tabindex was found in one of your focus-trap's multiple containers. Positive tabindexes are only supported in single-container focus-traps.");
    };
    /**
   * Gets the current activeElement. If it's a web-component and has open shadow-root
   * it will recursively search inside shadow roots for the "true" activeElement.
   *
   * @param {Document | ShadowRoot} el
   *
   * @returns {HTMLElement} The element that currently has the focus
   **/ var getActiveElement = function getActiveElement(el) {
        var activeElement = el.activeElement;
        if (!activeElement) return;
        if (activeElement.shadowRoot && activeElement.shadowRoot.activeElement !== null) return getActiveElement(activeElement.shadowRoot);
        return activeElement;
    };
    var tryFocus = function tryFocus(node) {
        if (node === false) return;
        if (node === getActiveElement(document)) return;
        if (!node || !node.focus) {
            tryFocus(getInitialFocusNode());
            return;
        }
        node.focus({
            preventScroll: !!config.preventScroll
        });
        // NOTE: focus() API does not trigger focusIn event so set MRU node manually
        state.mostRecentlyFocusedNode = node;
        if ($d5bc75faf976d2ed$var$isSelectableInput(node)) node.select();
    };
    var getReturnFocusNode = function getReturnFocusNode(previousActiveElement) {
        var node = getNodeForOption("setReturnFocus", previousActiveElement);
        return node ? node : node === false ? false : previousActiveElement;
    };
    /**
   * Finds the next node (in either direction) where focus should move according to a
   *  keyboard focus-in event.
   * @param {Object} params
   * @param {Node} [params.target] Known target __from which__ to navigate, if any.
   * @param {KeyboardEvent|FocusEvent} [params.event] Event to use if `target` isn't known (event
   *  will be used to determine the `target`). Ignored if `target` is specified.
   * @param {boolean} [params.isBackward] True if focus should move backward.
   * @returns {Node|undefined} The next node, or `undefined` if a next node couldn't be
   *  determined given the current state of the trap.
   */ var findNextNavNode = function findNextNavNode(_ref2) {
        var target = _ref2.target, event = _ref2.event, _ref2$isBackward = _ref2.isBackward, isBackward = _ref2$isBackward === void 0 ? false : _ref2$isBackward;
        target = target || $d5bc75faf976d2ed$var$getActualTarget(event);
        updateTabbableNodes();
        var destinationNode = null;
        if (state.tabbableGroups.length > 0) {
            // make sure the target is actually contained in a group
            // NOTE: the target may also be the container itself if it's focusable
            //  with tabIndex='-1' and was given initial focus
            var containerIndex = findContainerIndex(target, event);
            var containerGroup = containerIndex >= 0 ? state.containerGroups[containerIndex] : undefined;
            if (containerIndex < 0) {
                // target not found in any group: quite possible focus has escaped the trap,
                //  so bring it back into...
                if (isBackward) // ...the last node in the last group
                destinationNode = state.tabbableGroups[state.tabbableGroups.length - 1].lastTabbableNode;
                else // ...the first node in the first group
                destinationNode = state.tabbableGroups[0].firstTabbableNode;
            } else if (isBackward) {
                // REVERSE
                // is the target the first tabbable node in a group?
                var startOfGroupIndex = $d5bc75faf976d2ed$var$findIndex(state.tabbableGroups, function(_ref3) {
                    var firstTabbableNode = _ref3.firstTabbableNode;
                    return target === firstTabbableNode;
                });
                if (startOfGroupIndex < 0 && (containerGroup.container === target || (0, $1a0c6bd09b300b0d$export$4c063cf1350e6fed)(target, config.tabbableOptions) && !(0, $1a0c6bd09b300b0d$export$bebd5a1431fec25d)(target, config.tabbableOptions) && !containerGroup.nextTabbableNode(target, false))) // an exception case where the target is either the container itself, or
                //  a non-tabbable node that was given focus (i.e. tabindex is negative
                //  and user clicked on it or node was programmatically given focus)
                //  and is not followed by any other tabbable node, in which
                //  case, we should handle shift+tab as if focus were on the container's
                //  first tabbable node, and go to the last tabbable node of the LAST group
                startOfGroupIndex = containerIndex;
                if (startOfGroupIndex >= 0) {
                    // YES: then shift+tab should go to the last tabbable node in the
                    //  previous group (and wrap around to the last tabbable node of
                    //  the LAST group if it's the first tabbable node of the FIRST group)
                    var destinationGroupIndex = startOfGroupIndex === 0 ? state.tabbableGroups.length - 1 : startOfGroupIndex - 1;
                    var destinationGroup = state.tabbableGroups[destinationGroupIndex];
                    destinationNode = (0, $1a0c6bd09b300b0d$export$a4672efddb4181b8)(target) >= 0 ? destinationGroup.lastTabbableNode : destinationGroup.lastDomTabbableNode;
                } else if (!$d5bc75faf976d2ed$var$isTabEvent(event)) // user must have customized the nav keys so we have to move focus manually _within_
                //  the active group: do this based on the order determined by tabbable()
                destinationNode = containerGroup.nextTabbableNode(target, false);
            } else {
                // FORWARD
                // is the target the last tabbable node in a group?
                var lastOfGroupIndex = $d5bc75faf976d2ed$var$findIndex(state.tabbableGroups, function(_ref4) {
                    var lastTabbableNode = _ref4.lastTabbableNode;
                    return target === lastTabbableNode;
                });
                if (lastOfGroupIndex < 0 && (containerGroup.container === target || (0, $1a0c6bd09b300b0d$export$4c063cf1350e6fed)(target, config.tabbableOptions) && !(0, $1a0c6bd09b300b0d$export$bebd5a1431fec25d)(target, config.tabbableOptions) && !containerGroup.nextTabbableNode(target))) // an exception case where the target is the container itself, or
                //  a non-tabbable node that was given focus (i.e. tabindex is negative
                //  and user clicked on it or node was programmatically given focus)
                //  and is not followed by any other tabbable node, in which
                //  case, we should handle tab as if focus were on the container's
                //  last tabbable node, and go to the first tabbable node of the FIRST group
                lastOfGroupIndex = containerIndex;
                if (lastOfGroupIndex >= 0) {
                    // YES: then tab should go to the first tabbable node in the next
                    //  group (and wrap around to the first tabbable node of the FIRST
                    //  group if it's the last tabbable node of the LAST group)
                    var _destinationGroupIndex = lastOfGroupIndex === state.tabbableGroups.length - 1 ? 0 : lastOfGroupIndex + 1;
                    var _destinationGroup = state.tabbableGroups[_destinationGroupIndex];
                    destinationNode = (0, $1a0c6bd09b300b0d$export$a4672efddb4181b8)(target) >= 0 ? _destinationGroup.firstTabbableNode : _destinationGroup.firstDomTabbableNode;
                } else if (!$d5bc75faf976d2ed$var$isTabEvent(event)) // user must have customized the nav keys so we have to move focus manually _within_
                //  the active group: do this based on the order determined by tabbable()
                destinationNode = containerGroup.nextTabbableNode(target);
            }
        } else // no groups available
        // NOTE: the fallbackFocus option does not support returning false to opt-out
        destinationNode = getNodeForOption("fallbackFocus");
        return destinationNode;
    };
    // This needs to be done on mousedown and touchstart instead of click
    // so that it precedes the focus event.
    var checkPointerDown = function checkPointerDown(e) {
        var target = $d5bc75faf976d2ed$var$getActualTarget(e);
        if (findContainerIndex(target, e) >= 0) // allow the click since it ocurred inside the trap
        return;
        if ($d5bc75faf976d2ed$var$valueOrHandler(config.clickOutsideDeactivates, e)) {
            // immediately deactivate the trap
            trap.deactivate({
                // NOTE: by setting `returnFocus: false`, deactivate() will do nothing,
                //  which will result in the outside click setting focus to the node
                //  that was clicked (and if not focusable, to "nothing"); by setting
                //  `returnFocus: true`, we'll attempt to re-focus the node originally-focused
                //  on activation (or the configured `setReturnFocus` node), whether the
                //  outside click was on a focusable node or not
                returnFocus: config.returnFocusOnDeactivate
            });
            return;
        }
        // This is needed for mobile devices.
        // (If we'll only let `click` events through,
        // then on mobile they will be blocked anyways if `touchstart` is blocked.)
        if ($d5bc75faf976d2ed$var$valueOrHandler(config.allowOutsideClick, e)) // allow the click outside the trap to take place
        return;
        // otherwise, prevent the click
        e.preventDefault();
    };
    // In case focus escapes the trap for some strange reason, pull it back in.
    // NOTE: the focusIn event is NOT cancelable, so if focus escapes, it may cause unexpected
    //  scrolling if the node that got focused was out of view; there's nothing we can do to
    //  prevent that from happening by the time we discover that focus escaped
    var checkFocusIn = function checkFocusIn(event) {
        var target = $d5bc75faf976d2ed$var$getActualTarget(event);
        var targetContained = findContainerIndex(target, event) >= 0;
        // In Firefox when you Tab out of an iframe the Document is briefly focused.
        if (targetContained || target instanceof Document) {
            if (targetContained) state.mostRecentlyFocusedNode = target;
        } else {
            // escaped! pull it back in to where it just left
            event.stopImmediatePropagation();
            // focus will escape if the MRU node had a positive tab index and user tried to nav forward;
            //  it will also escape if the MRU node had a 0 tab index and user tried to nav backward
            //  toward a node with a positive tab index
            var nextNode; // next node to focus, if we find one
            var navAcrossContainers = true;
            if (state.mostRecentlyFocusedNode) {
                if ((0, $1a0c6bd09b300b0d$export$a4672efddb4181b8)(state.mostRecentlyFocusedNode) > 0) {
                    // MRU container index must be >=0 otherwise we wouldn't have it as an MRU node...
                    var mruContainerIdx = findContainerIndex(state.mostRecentlyFocusedNode);
                    // there MAY not be any tabbable nodes in the container if there are at least 2 containers
                    //  and the MRU node is focusable but not tabbable (focus-trap requires at least 1 container
                    //  with at least one tabbable node in order to function, so this could be the other container
                    //  with nothing tabbable in it)
                    var tabbableNodes = state.containerGroups[mruContainerIdx].tabbableNodes;
                    if (tabbableNodes.length > 0) {
                        // MRU tab index MAY not be found if the MRU node is focusable but not tabbable
                        var mruTabIdx = tabbableNodes.findIndex(function(node) {
                            return node === state.mostRecentlyFocusedNode;
                        });
                        if (mruTabIdx >= 0) {
                            if (config.isKeyForward(state.recentNavEvent)) {
                                if (mruTabIdx + 1 < tabbableNodes.length) {
                                    nextNode = tabbableNodes[mruTabIdx + 1];
                                    navAcrossContainers = false;
                                }
                            } else if (mruTabIdx - 1 >= 0) {
                                nextNode = tabbableNodes[mruTabIdx - 1];
                                navAcrossContainers = false;
                            }
                        // else, don't find in container order without considering direction too
                        }
                    }
                // else, no tabbable nodes in that container (which means we must have at least one other
                //  container with at least one tabbable node in it, otherwise focus-trap would've thrown
                //  an error the last time updateTabbableNodes() was run): find next node among all known
                //  containers
                } else // check to see if there's at least one tabbable node with a positive tab index inside
                //  the trap because focus seems to escape when navigating backward from a tabbable node
                //  with tabindex=0 when this is the case (instead of wrapping to the tabbable node with
                //  the greatest positive tab index like it should)
                if (!state.containerGroups.some(function(g) {
                    return g.tabbableNodes.some(function(n) {
                        return (0, $1a0c6bd09b300b0d$export$a4672efddb4181b8)(n) > 0;
                    });
                })) // no containers with tabbable nodes with positive tab indexes which means the focus
                //  escaped for some other reason and we should just execute the fallback to the
                //  MRU node or initial focus node, if any
                navAcrossContainers = false;
            } else // no MRU node means we're likely in some initial condition when the trap has just
            //  been activated and initial focus hasn't been given yet, in which case we should
            //  fall through to trying to focus the initial focus node, which is what should
            //  happen below at this point in the logic
            navAcrossContainers = false;
            if (navAcrossContainers) nextNode = findNextNavNode({
                // move FROM the MRU node, not event-related node (which will be the node that is
                //  outside the trap causing the focus escape we're trying to fix)
                target: state.mostRecentlyFocusedNode,
                isBackward: config.isKeyBackward(state.recentNavEvent)
            });
            if (nextNode) tryFocus(nextNode);
            else tryFocus(state.mostRecentlyFocusedNode || getInitialFocusNode());
        }
        state.recentNavEvent = undefined; // clear
    };
    // Hijack key nav events on the first and last focusable nodes of the trap,
    // in order to prevent focus from escaping. If it escapes for even a
    // moment it can end up scrolling the page and causing confusion so we
    // kind of need to capture the action at the keydown phase.
    var checkKeyNav = function checkKeyNav(event) {
        var isBackward = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        state.recentNavEvent = event;
        var destinationNode = findNextNavNode({
            event: event,
            isBackward: isBackward
        });
        if (destinationNode) {
            if ($d5bc75faf976d2ed$var$isTabEvent(event)) // since tab natively moves focus, we wouldn't have a destination node unless we
            //  were on the edge of a container and had to move to the next/previous edge, in
            //  which case we want to prevent default to keep the browser from moving focus
            //  to where it normally would
            event.preventDefault();
            tryFocus(destinationNode);
        }
    // else, let the browser take care of [shift+]tab and move the focus
    };
    var checkKey = function checkKey(event) {
        if ($d5bc75faf976d2ed$var$isEscapeEvent(event) && $d5bc75faf976d2ed$var$valueOrHandler(config.escapeDeactivates, event) !== false) {
            event.preventDefault();
            trap.deactivate();
            return;
        }
        if (config.isKeyForward(event) || config.isKeyBackward(event)) checkKeyNav(event, config.isKeyBackward(event));
    };
    var checkClick = function checkClick(e) {
        var target = $d5bc75faf976d2ed$var$getActualTarget(e);
        if (findContainerIndex(target, e) >= 0) return;
        if ($d5bc75faf976d2ed$var$valueOrHandler(config.clickOutsideDeactivates, e)) return;
        if ($d5bc75faf976d2ed$var$valueOrHandler(config.allowOutsideClick, e)) return;
        e.preventDefault();
        e.stopImmediatePropagation();
    };
    //
    // EVENT LISTENERS
    //
    var addListeners = function addListeners() {
        if (!state.active) return;
        // There can be only one listening focus trap at a time
        $d5bc75faf976d2ed$var$activeFocusTraps.activateTrap(trapStack, trap);
        // Delay ensures that the focused element doesn't capture the event
        // that caused the focus trap activation.
        state.delayInitialFocusTimer = config.delayInitialFocus ? $d5bc75faf976d2ed$var$delay(function() {
            tryFocus(getInitialFocusNode());
        }) : tryFocus(getInitialFocusNode());
        doc.addEventListener("focusin", checkFocusIn, true);
        doc.addEventListener("mousedown", checkPointerDown, {
            capture: true,
            passive: false
        });
        doc.addEventListener("touchstart", checkPointerDown, {
            capture: true,
            passive: false
        });
        doc.addEventListener("click", checkClick, {
            capture: true,
            passive: false
        });
        doc.addEventListener("keydown", checkKey, {
            capture: true,
            passive: false
        });
        return trap;
    };
    var removeListeners = function removeListeners() {
        if (!state.active) return;
        doc.removeEventListener("focusin", checkFocusIn, true);
        doc.removeEventListener("mousedown", checkPointerDown, true);
        doc.removeEventListener("touchstart", checkPointerDown, true);
        doc.removeEventListener("click", checkClick, true);
        doc.removeEventListener("keydown", checkKey, true);
        return trap;
    };
    //
    // MUTATION OBSERVER
    //
    var checkDomRemoval = function checkDomRemoval(mutations) {
        var isFocusedNodeRemoved = mutations.some(function(mutation) {
            var removedNodes = Array.from(mutation.removedNodes);
            return removedNodes.some(function(node) {
                return node === state.mostRecentlyFocusedNode;
            });
        });
        // If the currently focused is removed then browsers will move focus to the
        // <body> element. If this happens, try to move focus back into the trap.
        if (isFocusedNodeRemoved) tryFocus(getInitialFocusNode());
    };
    // Use MutationObserver - if supported - to detect if focused node is removed
    // from the DOM.
    var mutationObserver = typeof window !== "undefined" && "MutationObserver" in window ? new MutationObserver(checkDomRemoval) : undefined;
    var updateObservedNodes = function updateObservedNodes() {
        if (!mutationObserver) return;
        mutationObserver.disconnect();
        if (state.active && !state.paused) state.containers.map(function(container) {
            mutationObserver.observe(container, {
                subtree: true,
                childList: true
            });
        });
    };
    //
    // TRAP DEFINITION
    //
    trap = {
        get active () {
            return state.active;
        },
        get paused () {
            return state.paused;
        },
        activate: function activate(activateOptions) {
            if (state.active) return this;
            var onActivate = getOption(activateOptions, "onActivate");
            var onPostActivate = getOption(activateOptions, "onPostActivate");
            var checkCanFocusTrap = getOption(activateOptions, "checkCanFocusTrap");
            if (!checkCanFocusTrap) updateTabbableNodes();
            state.active = true;
            state.paused = false;
            state.nodeFocusedBeforeActivation = doc.activeElement;
            onActivate === null || onActivate === void 0 || onActivate();
            var finishActivation = function finishActivation() {
                if (checkCanFocusTrap) updateTabbableNodes();
                addListeners();
                updateObservedNodes();
                onPostActivate === null || onPostActivate === void 0 || onPostActivate();
            };
            if (checkCanFocusTrap) {
                checkCanFocusTrap(state.containers.concat()).then(finishActivation, finishActivation);
                return this;
            }
            finishActivation();
            return this;
        },
        deactivate: function deactivate(deactivateOptions) {
            if (!state.active) return this;
            var options = $d5bc75faf976d2ed$var$_objectSpread2({
                onDeactivate: config.onDeactivate,
                onPostDeactivate: config.onPostDeactivate,
                checkCanReturnFocus: config.checkCanReturnFocus
            }, deactivateOptions);
            clearTimeout(state.delayInitialFocusTimer); // noop if undefined
            state.delayInitialFocusTimer = undefined;
            removeListeners();
            state.active = false;
            state.paused = false;
            updateObservedNodes();
            $d5bc75faf976d2ed$var$activeFocusTraps.deactivateTrap(trapStack, trap);
            var onDeactivate = getOption(options, "onDeactivate");
            var onPostDeactivate = getOption(options, "onPostDeactivate");
            var checkCanReturnFocus = getOption(options, "checkCanReturnFocus");
            var returnFocus = getOption(options, "returnFocus", "returnFocusOnDeactivate");
            onDeactivate === null || onDeactivate === void 0 || onDeactivate();
            var finishDeactivation = function finishDeactivation() {
                $d5bc75faf976d2ed$var$delay(function() {
                    if (returnFocus) tryFocus(getReturnFocusNode(state.nodeFocusedBeforeActivation));
                    onPostDeactivate === null || onPostDeactivate === void 0 || onPostDeactivate();
                });
            };
            if (returnFocus && checkCanReturnFocus) {
                checkCanReturnFocus(getReturnFocusNode(state.nodeFocusedBeforeActivation)).then(finishDeactivation, finishDeactivation);
                return this;
            }
            finishDeactivation();
            return this;
        },
        pause: function pause(pauseOptions) {
            if (state.paused || !state.active) return this;
            var onPause = getOption(pauseOptions, "onPause");
            var onPostPause = getOption(pauseOptions, "onPostPause");
            state.paused = true;
            onPause === null || onPause === void 0 || onPause();
            removeListeners();
            updateObservedNodes();
            onPostPause === null || onPostPause === void 0 || onPostPause();
            return this;
        },
        unpause: function unpause(unpauseOptions) {
            if (!state.paused || !state.active) return this;
            var onUnpause = getOption(unpauseOptions, "onUnpause");
            var onPostUnpause = getOption(unpauseOptions, "onPostUnpause");
            state.paused = false;
            onUnpause === null || onUnpause === void 0 || onUnpause();
            updateTabbableNodes();
            addListeners();
            updateObservedNodes();
            onPostUnpause === null || onPostUnpause === void 0 || onPostUnpause();
            return this;
        },
        updateContainerElements: function updateContainerElements(containerElements) {
            var elementsAsArray = [].concat(containerElements).filter(Boolean);
            state.containers = elementsAsArray.map(function(element) {
                return typeof element === "string" ? doc.querySelector(element) : element;
            });
            if (state.active) updateTabbableNodes();
            updateObservedNodes();
            return this;
        }
    };
    // initialize container elements
    trap.updateContainerElements(elements);
    return trap;
};


console.log("Accessibility widget loaded.");
/**
 * Get the value of a cookie
 * Source: https://gist.github.com/wpsmith/6cf23551dd140fb72ae7
 * @param  {String} name  The name of the cookie
 * @return {String}       The cookie value
 */ function $75262146c0ddd5fa$var$getCookie(name) {
    var value = "; ".concat(document.cookie);
    var parts = value.split("; ".concat(name, "="));
    if (parts.length === 2) return parts.pop().split(";").shift();
}
/** Block / Layout Functions */ /* Accessibility Functions */ function $75262146c0ddd5fa$var$accessibilityInit() {
    var togglePanelButton = document.getElementById("accessibilityPanelToggle");
    var accessibilityAid = document.getElementById("accessibilityAid");
    var accessibilityPanel = document.getElementById("accessibilityPanel");
    var fontSizeButton = document.getElementById("fontSize");
    var highContrastButton = document.getElementById("highContrast");
    var reduceMotionButton = document.getElementById("reduceMotion");
    var html = document.querySelector("html");
    var videos = document.querySelectorAll("video[autoplay]");
    var accessibilityFocusTrap = (0, $d5bc75faf976d2ed$export$360440dfcba94c00)(accessibilityAid);
    function togglePanel() {
        if (accessibilityAid.classList.contains("accessibility-aid--active")) {
            accessibilityAid.classList.remove("accessibility-aid--active");
            togglePanelButton.setAttribute("aria-expanded", "false");
            accessibilityPanel.setAttribute("aria-hidden", "true");
            accessibilityPanel.style.display = "none";
            togglePanelButton.focus();
            accessibilityFocusTrap.deactivate();
        } else {
            accessibilityPanel.style.display = "flex";
            togglePanelButton.setAttribute("aria-expanded", "true");
            accessibilityPanel.setAttribute("aria-hidden", "false");
            accessibilityFocusTrap.activate();
            accessibilityAid.classList.add("accessibility-aid--active");
            setTimeout(function() {
                accessibilityPanel.focus();
            }, 25);
        }
    }
    togglePanelButton.addEventListener("click", togglePanel);
    // individual button actions
    if (fontSizeButton) {
        if ($75262146c0ddd5fa$var$getCookie("font-size") === "bigger") {
            fontSizeButton.classList.add("accessibility-option--active");
            document.documentElement.style.setProperty("font-size", "120%");
        }
        fontSizeButton.addEventListener("click", function() {
            var fontSizeCookie = $75262146c0ddd5fa$var$getCookie("font-size");
            if (fontSizeCookie !== "bigger") {
                document.cookie = "font-size=bigger;max-age=".concat(604800, ";path=/");
                fontSizeButton.classList.add("accessibility-option--active");
                document.documentElement.style.setProperty("font-size", "120%");
            } else {
                document.cookie = "font-size=initial;max-age=".concat(604800, ";path=/");
                fontSizeButton.classList.remove("accessibility-option--active");
                document.documentElement.style.setProperty("font-size", "100%");
            }
        });
    }
    if (highContrastButton) {
        if ($75262146c0ddd5fa$var$getCookie("high-contrast") === "true") highContrastButton.classList.add("accessibility-option--active");
        highContrastButton.addEventListener("click", function() {
            var highContrastCookie = $75262146c0ddd5fa$var$getCookie("high-contrast");
            if (highContrastCookie !== "true") {
                document.cookie = "high-contrast=true;max-age=".concat(604800, ";path=/");
                highContrastButton.classList.add("accessibility-option--active");
                html.classList.add("high-contrast");
            } else {
                document.cookie = "high-contrast=initial;max-age=".concat(604800, ";path=/");
                highContrastButton.classList.remove("accessibility-option--active");
                html.classList.remove("high-contrast");
            }
        });
    }
    if (reduceMotionButton) {
        if ($75262146c0ddd5fa$var$getCookie("reduce-motion") === "true") reduceMotionButton.classList.add("accessibility-option--active");
        reduceMotionButton.addEventListener("click", function() {
            var reduceMotionCookie = $75262146c0ddd5fa$var$getCookie("reduce-motion");
            if (reduceMotionCookie !== "true") {
                document.cookie = "reduce-motion=true;max-age=".concat(604800, ";path=/");
                reduceMotionButton.classList.add("accessibility-option--active");
                html.classList.add("reduce-motion");
                // gsap.globalTimeline.pause();
                videos.forEach(function(video) {
                    return video.pause();
                });
            } else {
                document.cookie = "reduce-motion=initial;max-age=".concat(604800, ";path=/");
                reduceMotionButton.classList.remove("accessibility-option--active");
                html.classList.remove("reduce-motion");
                // gsap.globalTimeline.play();
                videos.forEach(function(video) {
                    return video.play();
                });
            }
        });
    }
}
/* Initialize Everything */ document.addEventListener("DOMContentLoaded", function() {
    /* Accessibility Cookie Fixes */ if ($75262146c0ddd5fa$var$getCookie("reduce-motion") === "true") {
        var videos = document.querySelectorAll("video[autoplay]");
        videos.forEach(function(video) {
            return video.pause();
        });
    }
    if ($75262146c0ddd5fa$var$getCookie("high-contrast") === "true") {
        var html = document.querySelector("html");
        html.classList.add("high-contrast");
    }
    if ($75262146c0ddd5fa$var$getCookie("reduce-motion") === "true") {
        var html1 = document.querySelector("html");
        html1.classList.add("reduce-motion");
    }
    /* Accessibility Panel */ if (document.getElementById("accessibilityPanelToggle")) $75262146c0ddd5fa$var$accessibilityInit();
});

})();
//# sourceMappingURL=accessibility-widget.js.map
